'use strict';

angular.module('atex.dam').directive('damUsersList', [ 'DamService','$translate', '$timeout', function (DamService,$translate,$timeout) {
  return {
    require: '^ngModel',
    scope: {
      model: '=ngModel',
      userProviders: '=',
      placeHolder: '=',
      currentUser: '=',
      allowNewUsers: '=',
      useId: '=',
      useEvents: '=',
      useOperator: '=',
      filterType: '='
    },

    controller: function ($scope) {
      $scope.tags = undefined;

      $scope.selectPlaceHolder = $scope.placeHolder || '_ASSIGNEES_';
      $scope._allowNewUsers = $scope.allowNewUsers || false;
      $scope._useId = $scope.useId || false;
      $scope._useEvents = $scope.useEvents || false;
      var list = [];

      if ($scope.userProviders && typeof $scope.userProviders === 'function') {
        $scope.userProviders().then(function (users) {
          users.forEach(function (user) {
            var id = ($scope._useId) ? user.principalId : user.name;
            list.push({id: id, text: user.name, type: user.type});
          });
          if ($scope.currentUser) {
            // Add to beginning of array
            list.unshift({id: "%%CURRENT-USER%%", text:  $translate.getTranslationTable().__CURRENT_USER__, type: "user"});
          }
          $scope.tags = list;
        });
      } else {
        DamService.getUsersAndGroups().then(function (users) {
          users.forEach(function (user) {
            var id = ($scope._useId) ? user.principalId : user.name;
            if (id && ($scope.filterType === undefined || $scope.filterType === user.type)) {
              list.push({id: id, text: user.name || id, type: user.type});
            }
          });
          if ($scope.currentUser) {
            // Add to beginning of array
            list.unshift({
              id: "%%CURRENT-USER%%",
              text: $translate.getTranslationTable().__CURRENT_USER__,
              type: "user"
            });
          }
          $scope.tags = list;
        });
      }
    },

    link: function (scope, element, attrs, ngModel) {
      function format(tag) {
        if (tag.type === 'group') {
          return "<i class='fa fa-group'></i>&nbsp;" + tag.text;
        } else if (tag.type === 'user') {
          return "<i class='fa fa-user'></i>&nbsp;" + tag.text;
        } else if (scope._allowNewUsers) {
          return "<i class='fa fa-user'></i>&nbsp;" + tag.text;
        }
      }

      function toJson(_string, json) {
        json = (!json) ? {} : json;
        var originalJson = json;
        try {
          if (_string) {
            var properties = _string.split(";") || [];
            _.each(properties, function (property) {
              var split = property.split(":");
              json[split[0].trim()] = split[1].trim();
            });
          }
        } catch (error) {
          json = originalJson;
          console.error(error);
        }
        return json;
      }

      element.attr('title', attrs.title);

      $(element).select2({
        placeholder: $translate.getTranslationTable()[scope.selectPlaceHolder],
        formatResult: format,
        formatSelection: format,
        tags: function () {
          return scope.tags;
        },
        formatNoMatches: function (term) {
          return '';
        },
        containerCss: toJson(attrs.style,{"width":"100%"})
      });

      ngModel.$render = function (value) {
        var entries = angular.copy(ngModel.$viewValue) || [];

        var tags = [];
        entries.forEach(function (entry) {
          var text = entry;
          if (entry === '%%CURRENT-USER%%') {
            text = $translate.getTranslationTable().__CURRENT_USER__;
          }

          if(scope._useId && scope.tags) {
            var findIt = _.find(scope.tags,function(tag) {
              return (tag && tag.id) === entry;
            });
            if (findIt && findIt.text) {
              text = findIt.text;
            } else {
              text = entry;
            }
          }
          tags.push({id: entry, text: text, type: 'user'});
        });

        element.select2('data', tags);
      };

      element.on('select2-open', function () {
        if(scope._useEvents) {
          atex.dam.AngularUtils.width(element, 0);
          atex.dam.AngularUtils.getNode(element, '.input-group-addon').hide();

          var node = atex.dam.AngularUtils.getNode(element, '.select2-choices');
          $(node).css('border-radius', '4px 4px 0 0');
          if(scope.useOperator) {
            $(node).css('border-right', '1px solid #5897fb');
            $(node).css('box-shadow', 'none');
          }

          var width = atex.dam.AngularUtils.getWidth(element);
          $('.select2-drop-active').width(width - 2);
        }
      });

      element.on('select2-close', function () {
        if(scope._useEvents) {
          atex.dam.AngularUtils.getNode(element, '.input-group-addon').show();

          var node = atex.dam.AngularUtils.getNode(element, '.select2-choices');
          if(scope.useOperator) {
            $(node).css('border-radius', '4px 0 0 4px');
            $(node).css('border-right', 'none');
          } else {
            $(node).css('border-radius', '4px');
            $(node).css('border-right', '1px solid #aaa;');
          }

          var width = atex.dam.AngularUtils.getWidth(element);
          $('.select2-drop-active').width(width + 2);
        }
      });

      element.on('change', function (event) {
        var objects = angular.copy(element.select2('data'));

        var values = [];
        objects.forEach(function (object) {
          values.push(object.id);
        });

        $timeout(function () {
          ngModel.$setViewValue(values);
        });

      });
    }
  };
}]);
